import React, { Fragment } from "react";
import makeStyles from "@mui/styles/makeStyles";

import Container from "@mui/material/Container";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";

const useStyles = (scrollVisible, organizeTable) =>
  makeStyles(theme => ({
    panel: {
      // backgroundColor: "white",
      paddingLeft: 0,
      paddingRight: scrollVisible ? theme.spacing(0) : theme.spacing(4),
    },

    loadingContainer: {
      height: organizeTable ? "calc(100vh - 410px)" : "calc(100vh - 300px)",
    },
  }));

const MediaBrowser = props => {
  const {
    searchBar,
    totalsHeader,
    loaded,
    mediaTable,
    scrollVisible,
    organizeTable,
    maxWidth = "lg",
  } = props;
  const classes = useStyles(scrollVisible, organizeTable)();

  return (
    <Fragment>
      <Fragment>{searchBar}</Fragment>
      <Fragment>{totalsHeader}</Fragment>
      <Container maxWidth={maxWidth} classes={{ root: classes.panel }}>
        {loaded ? (
          <Fragment>{mediaTable}</Fragment>
        ) : (
          <div className={classes.loadingContainer}>
            <PanelLoadingIndicator />
          </div>
        )}
      </Container>
    </Fragment>
  );
};

export default MediaBrowser;
